import { Link } from "react-router-dom";
import { LogOut, Home, Wifi, WifiOff } from "lucide-react";
import { Brand } from "@/components/Brand";
import { Clocks } from "@/components/Clocks";

const ROLE_LABEL = { admin: "അഡ്മിൻ", staff: "സ്റ്റാഫ്", customer: "കസ്റ്റമർ" };

export const PortalHeader = ({ title, user, onLogout, connected, right }) => (
  <header data-testid="portal-header" className="sticky top-0 z-40 glass">
    <div className="max-w-[1200px] mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
      <div className="flex items-center gap-3 min-w-0">
        <Link to="/" data-testid="portal-home-link" className="shrink-0"><Brand ml compact /></Link>
        <span className="text-[var(--muted-text)]">|</span>
        <h1 className="text-sm sm:text-base font-bold truncate">{title}</h1>
      </div>
      <div className="flex items-center gap-2">
        <Clocks />
        {right}
        {connected !== undefined && (
          <span data-testid="ws-status" className={`hidden sm:inline-flex items-center gap-1 text-[10px] font-semibold ${connected ? "text-emerald-600" : "text-slate-400"}`}>
            {connected ? <Wifi size={12} /> : <WifiOff size={12} />} {connected ? "LIVE" : "OFFLINE"}
          </span>
        )}
        <span data-testid="portal-user-badge" className="hidden sm:inline-flex items-center rounded-full border border-[var(--line)] bg-white px-3 h-8 text-xs font-semibold">{user?.name} · {ROLE_LABEL[user?.role]}</span>
        <Link to="/" className="btn-ghost w-9 h-9 rounded-full inline-flex items-center justify-center" data-testid="portal-home-button"><Home size={15} /></Link>
        <button onClick={onLogout} data-testid="logout-button" className="btn-ghost rounded-full h-9 px-3.5 inline-flex items-center gap-1.5 text-xs font-bold"><LogOut size={14} /> ലോഗൗട്ട്</button>
      </div>
    </div>
  </header>
);

export const StatCard = ({ label, value, sub, accent, testId }) => (
  <div data-testid={testId} className="card rounded-2xl p-4">
    <p className="label-caps text-[10px]">{label}</p>
    <p className={`font-num text-2xl sm:text-3xl font-bold mt-2 ${accent ? "text-[var(--accent-c)]" : ""}`}>{value}</p>
    {sub && <p className="text-[11px] text-[var(--muted-text)] mt-1">{sub}</p>}
  </div>
);

export const Avatar = ({ src, name, size = "w-12 h-12", className = "" }) => (
  <div className={`${size} rounded-2xl overflow-hidden bg-[var(--charcoal-2)] border border-[var(--line)] shrink-0 flex items-center justify-center ${className}`}>
    {src ? <img src={src} alt={name} className="w-full h-full object-cover" draggable={false} /> : <span className="font-display text-xl font-bold text-[var(--accent-c)]">{name?.[0]}</span>}
  </div>
);
